module.exports = __webpack_public_path__ + "img/showcase-1.6890b38c.png";